import { ChangeEvent, memo } from 'react'
import { cn } from '@global/utils/tailwind'

interface RadioCardProps {
  id?: string
  name?: string
  title: string
  description?: string
  value: string
  checked: boolean
  className?: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const RadioCard = memo(
  ({ id, name, title, description, value, checked, className, onChange }: RadioCardProps) => (
    <label className={cn('cursor-pointer', className)}>
      <div
        className={cn(
          'border rounded-lg px-[14px] py-[12px] border-md hover:border-cv-primary flex items-start',
          {
            'border-cv-primary bg-cv-blue-50': checked,
            'border-cv-blue-200': !checked,
          },
        )}
      >
        <div className="relative flex items-center cursor-pointer mt-[2px]">
          <input
            id={id}
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            type="radio"
            className="peer size-[14px] cursor-pointer appearance-none rounded-full border border-cv-blue-200 checked:border-cv-primary checked:border-4 transition-all"
          />
        </div>
        <div className="ml-3">
          <p className="text-[12px] text-slate-800 font-semibold select-none">{title}</p>
          {!!description && (
            <p className="text-[12px] text-gray-500 select-none mt-[4px]">{description}</p>
          )}
        </div>
      </div>
    </label>
  ),
)

RadioCard.displayName = 'RadioCard'
